export enum TabAnimationsPhases {
    Open = "open",
    Closed = "closed",
    OpenReduced = "openReduced"
}